import ApiService from './ApiService'

const resourceUrl = `${ApiService.prefix}rest/i18n/lookup`

export default {
  get(lookUpId) {
    return ApiService.get(`${resourceUrl}/data?id=${lookUpId}`)
  },
  post(data) {
    return ApiService.post(`${resourceUrl}/translate`, data)
  },
  getLanguageSelectValues(lookup) {
    return lookup.translations.map((translation) => ({
      label: `${translation.language.name} (${translation.language.code})`,
      value: translation.language.id,
    }))
  },
}
